<div class="container" [class.dark]="darkTheme">
  <div [style.visibility]="showLoadingBar ? 'visible' : 'hidden'">
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.sm="column" fxLayoutGap.sm="10px" fxLayout.xs="column" fxLayoutGap.xs="10px">
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayoutGap.xs="5px" class="form-container">
      <mat-form-field appearance="fill" class="slim">
        <mat-label>Company</mat-label>
        <input type="text" placeholder="Search" aria-label="Number" matInput [matAutocomplete]="companyControl"
          [formControl]="companyAutocomplete" (keyup)="onCompanyKeyUp($event)" autocomplete="off" #companyInput
          #companyTrigger="matAutocompleteTrigger">
        <mat-autocomplete #companyControl="matAutocomplete" autoActiveFirstOption [displayWith]="displayCompany" >
          <mat-option *ngFor="let comp of companies | async" [value]="comp">
            {{ comp.name }}
          </mat-option>
        </mat-autocomplete>
        <button *ngIf="companyAutocomplete.value" mat-button matSuffix mat-icon-button aria-label="Clear" tabindex="-1"
          (click)="onClickClearCompanyAutocomplete(); $event.stopPropagation(); userTrigger.closePanel(); companyTrigger.openPanel();">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill" class="slim">
        <mat-label>User</mat-label>
        <input type="text" placeholder="Search" aria-label="Number" matInput [matAutocomplete]="userControl"
          [formControl]="userAutocomplete" (keyup)="onUserKeyUp($event)" autocomplete="off" #userInput
          #userTrigger="matAutocompleteTrigger">
        <mat-autocomplete #userControl="matAutocomplete" autoActiveFirstOption [displayWith]="displayUser">
          <mat-option *ngFor="let user of users | async" [value]="user">
            {{ user.email }}
          </mat-option>
        </mat-autocomplete>
        <button *ngIf="userAutocomplete.value" mat-button matSuffix mat-icon-button aria-label="Clear" tabindex="-1"
          (click)="onClickClearUserAutocomplete();  $event.stopPropagation(); companyTrigger.closePanel(); userTrigger.openPanel();">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="20px" fxLayoutGap.xs="5px" fxLayoutAlign="end center">
      <button mat-flat-button color="accent" (click)="onClickViewAsUser()" [disabled]="disabledViewAs">
        <mat-icon>badge</mat-icon> View As
      </button>
      <button mat-flat-button color="primary" (click)="onClickRevert()" [disabled]="disabledRevert">
        <mat-icon>undo</mat-icon> Revert
      </button>
    </div>
  </div>
</div>
